<template>
  <div id="match-result">
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="checkPage"
    />
    <swiper :options="swiperOption" ref="mySwiper" v-if="isShow">
      <swiper-slide v-if="this.$route.params.profile">
        <router-view></router-view>
      </swiper-slide>
      <!-- Total -->
      <swiper-slide>
        <div class="slide-wrapper">
          <div class="slide-container">
            <div class="circle-chart-container">
              <comp-chart-circle :data="rateData"></comp-chart-circle>
              <div class="rate-overlay">{{ rateData }}%</div>
            </div>
            <p class="match-text">{{ totalMent }}</p>
            <template v-if="friends.length">
              <div class="users">
                <template v-for="(friend, index) in friends">
                  <comp-profile
                    v-if="friend.userSeqId != matchUser"
                    v-bind:key="index"
                    :userInitial="friend.nickname.split('')[0]"
                    :profileImage="friend.photoUrl"
                    :badgeBtn="badgeBtn"
                    :badge=(friend.order)
                    @click.native="showDetail(friend.userSeqId, friend.nickname)"
                  />
                </template>
              </div>
              <div class="view-more" @click="more">{{ $t('match.more') }}</div>
            </template>
          </div>
        </div>
      </swiper-slide>

      <!-- Part -->
      <template>
        <swiper-slide v-for="(data, index) in reportDatas" :key="index">
          <div class="slide-wrapper">
            <div class="slide-container">
              <match-result-detail
                :myInit="myInit"
                :myName="myName"
                :myType="data.myType"
                :myItem="data.myScore"
                :yourInit="yourInit"
                :yourName="yourName"
                :yourType="data.yourType"
                :yourItem="data.yourScore"
                :matchDetail="data.matchMent"
                :myTypeDetail="data.myReport"
                :yourTypeDetail="data.yourReport"
              />
            </div>
          </div>
        </swiper-slide>
      </template>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import CompHeader from '@/components/CompHeader';
import CompChartCircle from '@/components/CompChartCircle';
import CompProfile from '@/components/CompProfile';
import MatchResultDetail from '@/components/MatchResultDetail';
import RESPONSE from '@/constants/response';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'match-result',
  mixins: [
    common,
  ],
  components: {
    swiper,
    swiperSlide,
    CompHeader,
    CompProfile,
    CompChartCircle,
    MatchResultDetail,
    CompLoading,
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        navigation: {
          nextEl: '.btn-next',
        },
        on: {
          slideChangeTransitionEnd() {
            if (this.slides[this.activeIndex].getElementsByClassName('detail-stat').length > 0) {
              this.slides[this.activeIndex].getElementsByClassName('user-ind-you')[0].classList.remove('init-pos');
              this.slides[this.activeIndex].getElementsByClassName('user-ind-me')[0].classList.remove('init-pos');
            }
          },
        },
      },
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('match.resultHeader'),

      myName: '',
      myInit: '',
      yourName: '',
      yourInit: '',

      isShow: false,
      rateData: '',
      totalMent: '',
      reportDatas: [],
      type: this.$route.query.type,

      friends: [],
      badgeBtn: '',

      isLoading: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    matchUser() {
      return this.$route.params.id;
    },
  },
  methods: {
    getResult() {
      this.isLoading = true;
      this.myName = this.$store.getters.getUserName;
      this.myInit = this.myName.split('')[0];
      this.yourName = this.$route.query.username;
      this.yourInit = this.yourName.split('')[0];
      const matchUser = this.$route.params.id;
      this.$store.dispatch('getMatchResult', { matchUser })
        .then((result) => {
          const data = result.data;
          if (result.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getResult();
              } else {
                this.invalidateLogin();
              }
            });
          } else if (result.status === RESPONSE.SUCCESS.CODE) {
            this.rateData = data.Total.percent;
            this.totalMent = data.Total.ment;
            this.setResult(data);
            this.isShow = true;
          }
          this.isLoading = false;
        });
      if (this.$route.query.type) {
        const type = this.$route.query.type;
        this.$store.dispatch('getMc6Detail', { type }).then(({ data }) => {
          this.badgeBtn = 'on';
          this.friends = data.friends;

          this.isLoading = false;
        });
      }
    },
    setResult(data) {
      // R: 우뇌, A: 진취, S: 사회, P: 실천, B: 신체, L: 좌뇌
      this.reportDatas = [
        {
          // 우뇌
          title: data.R.title,
          matchMent: data.R.matchment,
          myScore: data.R.myScore,
          myType: data.R.BRAINTYPE,
          myReport: data.R.MATCHREPORT,
          yourScore: data.R.yourScore,
          yourType: data.R.youMent.BRAINTYPE,
          yourReport: data.R.youMent.MATCHREPORT,
        },
        {
          // 진취
          title: data.A.title,
          matchMent: data.A.matchment,
          myScore: data.A.myScore,
          myType: data.A.BRAINTYPE,
          myReport: data.A.MATCHREPORT,
          yourScore: data.A.yourScore,
          yourType: data.A.youMent.BRAINTYPE,
          yourReport: data.A.youMent.MATCHREPORT,
        },
        {
          // 사회
          title: data.S.title,
          matchMent: data.S.matchment,
          myScore: data.S.myScore,
          myType: data.S.BRAINTYPE,
          myReport: data.S.MATCHREPORT,
          yourScore: data.S.yourScore,
          yourType: data.S.youMent.BRAINTYPE,
          yourReport: data.S.youMent.MATCHREPORT,
        },
        {
          // 실천
          title: data.P.title,
          matchMent: data.P.matchment,
          myScore: data.P.myScore,
          myType: data.P.BRAINTYPE,
          myReport: data.P.MATCHREPORT,
          yourScore: data.P.yourScore,
          yourType: data.P.youMent.BRAINTYPE,
          yourReport: data.P.youMent.MATCHREPORT,
        },
        {
          // 신체
          title: data.B.title,
          matchMent: data.B.matchment,
          myScore: data.B.myScore,
          myType: data.B.BRAINTYPE,
          myReport: data.B.MATCHREPORT,
          yourScore: data.B.yourScore,
          yourType: data.B.youMent.BRAINTYPE,
          yourReport: data.B.youMent.MATCHREPORT,
        },
        {
          // 좌뇌
          title: data.L.title,
          matchMent: data.L.matchment,
          myScore: data.L.myScore,
          myType: data.L.BRAINTYPE,
          myReport: data.L.MATCHREPORT,
          yourScore: data.L.yourScore,
          yourType: data.L.youMent.BRAINTYPE,
          yourReport: data.L.youMent.MATCHREPORT,
        },
      ];
    },
    showDetail(id, nickname) {
      this.$router.push({
        path: `/match/result/${id}`,
        query: {
          username: nickname,
          type: this.$route.query.type,
        },
      });
      this.getResult();
    },
    checkPage() {
      if (this.$route.query.type) {
        this.goPage('/mc6');
      } else {
        this.goPrevious();
      }
    },
    more() {
      this.$router.push({
        path: '/match/list',
        query: {
          type: this.$route.query.type,
        },
      });
    },
  },
  created() {
    this.getResult();
  },
  updated() {
    if (this.isShow) {
      this.$el.querySelectorAll('#match-result-detail').forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.style.height = `${window.innerHeight - 94}px`;
      });
    }
  },
};
</script>

<style lang="scss" src="../../scss/match-result.scss"></style>



// WEBPACK FOOTER //
// src/views/match/match-result.vue